import { useState } from "react";
import { useSession } from "../hooks";
import { SecurityCards } from "./Security";
import { LanguageSwitch } from "./LanguageSwitch";
import { t } from "../i18n";
import { logo, siteName, useBranding } from "../brand";

// MFAGate is all someone sees whose groups need two-step verification they
// have not set up: setting it up, then going on, or signing out.
export function MFAGate({ onReady, onSignOut }: { onReady: () => void; onSignOut: () => void }) {
  const session = useSession();
  const brand = useBranding();
  const [note, setNote] = useState("");

  async function next() {
    setNote("");
    try {
      const me = await session.api.me();
      if (me.mfa_setup_required) setNote(t("Add a passkey or turn on an authenticator app first."));
      else onReady();
    } catch {
      setNote(t("Could not reach the server."));
    }
  }

  return (
    <main className="page mfa-gate">
      <header className="mfa-gate-head">
        <img src={logo(192, brand)} alt="" width={40} height={40} />
        <div>
          <h1>{t("Set up two-step verification")}</h1>
          <p className="login-lede">{t("Your groups need it before you use {name}: add a passkey, or turn on an authenticator app. Then open {name}.", { name: siteName(brand) })}</p>
        </div>
      </header>
      <SecurityCards />
      {note && (
        <p className="error" role="alert">
          {note}
        </p>
      )}
      <div className="form-actions">
        <button className="ghost" onClick={onSignOut}>
          {t("Sign out")}
        </button>
        <button className="primary" onClick={() => void next()}>
          {t("Open {name}", { name: siteName(brand) })}
        </button>
      </div>
      <LanguageSwitch />
    </main>
  );
}
